import { Box, Typography } from "@mui/material"
import useErrorsCheck from "hooks/use_errors_check"
import useAppStore from "store/app"
import useTranslation from "hooks/use_translation"

import HumanGender from "components/shared/fields/HumanGender"
import HumanWeight from "components/shared/fields/HumanWeight"
import HumanHeight from "components/shared/fields/HumanHeight"
import HumanAge from "components/shared/fields/HumanAge"

import SecondaryButton from "components/shared/buttons/SecondaryButton"

const PersonalInfo = () => {
  // const userFields = useAppStore((state) => state.user)
  const fields = useAppStore((state) => state.fields)
  const nextAnamnesisStep = useAppStore((state) => state.nextAnamnesisStep)
  const updateAnamnesis = useAppStore((state) => state.updateAnamnesis)
  const t = useTranslation()

  const { validate } = useErrorsCheck(["gender", "height", "weight", "age"])

  const handleSubmit = (event) => {
    event.preventDefault()

    const valid = validate()

    if (!valid) return

    const params = {
      // email: userFields.email,
      // name: userFields.first_name,
      // phone: userFields.phone_number,

      height: parseInt(fields.height.input_value),
      weight: parseInt(fields.weight.input_value),
      gender: fields.gender.input_value,
      age: fields.age.input_value,
      // age: parseInt(fields.age.input_value) >= 16 ? "ADULT" : "CHILDREN",
    }

    updateAnamnesis(params).then(() => nextAnamnesisStep())
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        {t?.fields?.gender_title_long}
      </Typography>
      <HumanGender />

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, mt: 2 }}>
        {t?.fields?.height_title_long}
      </Typography>
      <HumanHeight />

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, mt: 2 }}>
        {t?.fields?.weight_title_long}
      </Typography>
      <HumanWeight />

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, mt: 2 }}>
        {t?.fields?.age_title_long}
      </Typography>
      <HumanAge />

      <SecondaryButton
        text={t?.anamnesis?.next_btn}
        type="submit"
        fullWidth
        sx={{ alignSelf: "flex-end" }}
      />
    </Box>
  )
}

export default PersonalInfo
